import { Observable } from 'rxjs/Rx'

import { HttpHelper, Utils } from '../../../../../helpers'
import { Store, ModelMapper, BaseJsonModelInterface } from '../../../../../model-repository'
import { BaseModel } from '../../../../../data/models'
import { IOperationRequest } from './../'
import { IOperationRequestParameter } from './../'
import { JsonApiOperationRequest } from './json-api-operation-request'

type PayloadGenerator = (request: IOperationRequest) => IOperationRequest

export class JsonApiProcessor {

  private _payloadAugmentationStategies: Map<string, PayloadGenerator>

  constructor(
    private _httpHelper: HttpHelper,
    private _store: Store,
    private _modelMapper: ModelMapper,
    private _utils: Utils,
    private _operationRequest: JsonApiOperationRequest
  ) {
    this._payloadAugmentationStategies = new Map<string, PayloadGenerator>()

    this._payloadAugmentationStategies.set('get', this._augmentRequestWithNothing)
    this._payloadAugmentationStategies.set('post', this._augmentRequestWithType)
  }

  public process<T extends BaseModel>(requestParams: IOperationRequestParameter): Observable<T|T[]> {
    const request = this._operationRequest.generate(requestParams)
    return this._processRequest(request)
  }

  private _processRequest<T>(request): Observable<T | T[]> {
    request = this._augmentPayload(request)
    return this._httpHelper[request.httpMethod](request.url, request.payload)
      .map((response) => {
        response = this._store.sync(response) || {}
        // TODO [GitHub Issue]: It would be better to have a custom class for arrays that would respond to type
        const type = Array.isArray(response) ? (response[0] || {}).type : response.type
        return type ? this._modelMapper.mapToModel(type, response) : response
      })
  }

  private _augmentPayload(request: IOperationRequest): IOperationRequest {
    const augmentator = this._payloadAugmentationStategies.get(request.httpMethod)
    return augmentator.call(this, request)
  }

  private _augmentRequestWithNothing(request: IOperationRequest) {
    return request
  }

  private _augmentRequestWithType(request: IOperationRequest) {
    request.payload = Object.assign({}, request.payload, this._modelToJsonApi(new request.returnType()))
    return request
  }

  private _modelToJsonApi(model: BaseModel): {data: {}} {
    return {
      data: {
        type: (this._modelMapper.mapToJson(model) as BaseJsonModelInterface).type
      }
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/operation/operation-processors/json-api-processor/json-api-processor.ts